export const BUSINESS_MODEL_MARKETPLACE = 'marketplace';
export const BUSINESS_MODEL_DROPSHIP = 'dropship';

export const BusinessModelDisplayName = {
  [BUSINESS_MODEL_MARKETPLACE]: 'Marketplace',
  [BUSINESS_MODEL_DROPSHIP]: 'Dropship',
};

export const PAYMENT_CYCLE_DAILY = 'daily';
export const PAYMENT_CYCLE_WEEKLY = 'weekly';
export const PAYMENT_CYCLE_BIWEEKLY = 'biweekly';
export const PAYMENT_CYCLE_MONTHLY = 'monthly';

export const PaymentCycleDisplayName = {
  [PAYMENT_CYCLE_DAILY]: 'Daily',
  [PAYMENT_CYCLE_WEEKLY]: 'Weekly',
  [PAYMENT_CYCLE_BIWEEKLY]: 'Biweekly',
  [PAYMENT_CYCLE_MONTHLY]: 'Monthly',
};

export const HANDLING_FEE_ORDER = 'order';
export const HANDLING_FEE_LINE = 'line';
export const HANDLING_FEE_NONE = 'none';

export const HandlingFeeDisplayName = {
  [HANDLING_FEE_ORDER]: 'Order',
  [HANDLING_FEE_LINE]: 'Line',
  [HANDLING_FEE_NONE]: 'None',
};

export const PAYMENT_TERMS_NET_30 = '30';
export const PAYMENT_TERMS_NET_45 = '45';
export const PAYMENT_TERMS_NET_60 = '60';
export const PAYMENT_TERMS_NET_90 = '90';
export const PAYMENT_TERMS_NET_120 = '120';

export const PaymentTermsDisplayName = {
  [PAYMENT_TERMS_NET_30]: 'Net 30',
  [PAYMENT_TERMS_NET_45]: 'Net 45',
  [PAYMENT_TERMS_NET_60]: 'Net 60',
  [PAYMENT_TERMS_NET_90]: 'Net 90',
  [PAYMENT_TERMS_NET_120]: 'Net 120',
};
